import React, {Component} from 'react';
import PhotoSelector from './photo_selector/';

export default class CustomersIntoBrandAmbassadors extends Component {
    render(){
        const {displayStatic} = this.props;
        const iPadImg = require('images/brand_ambassadors/rose_gold_ipad.png');
        const iPadImgMobile = require('images/brand_ambassadors/customers_into_brand_ambassadors_mobile.png');
        const customersIntoBrandAmbassadorsClass = displayStatic ? 'customers-into-brand-ambassadors-text-web-static' : 'customers-into-brand-ambassadors-text';

        return(
            <div className='gr-12 customers-into-brand-ambassadors'>
                    <div className={customersIntoBrandAmbassadorsClass}>
                        <h1>Turn customers into brand ambassadors</h1>
                        <p>Social Native’s data centric approach to ambassador marketing enables you to create a database through brand affinity matching technology; centralizing processes, eliminating redundancies and creating an accessible network of true ambassadors.</p>
                    </div>

                    <div className='show hide@xs customers-into-brand-ambassadors-media'>
                        <img src={iPadImg} />
                        <PhotoSelector />
                    </div>

                    <div className='hide show@xs customers-into-brand-ambassadors-img-mobile'>
                        <img src={iPadImgMobile} />
                    </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./web/js/components/brand_ambassadors/customers_into_brand_ambassadors.js